import React from 'react';
import '../css/WhatsAppButton.css';
import { buildWhatsAppUrl } from "../config/whatsapp";
import { useContactSettings } from "./ContactSettingsProvider";

function WhatsAppButton() {
  const { whatsappPhone } = useContactSettings();
  const whatsappUrl = buildWhatsAppUrl(undefined, whatsappPhone);

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
      title="Contactanos por WhatsApp"
      aria-label="Abrir WhatsApp"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="whatsapp-icon"
      >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
      <span className="whatsapp-tooltip">¿Preguntas? Contactanos por WhatsApp</span>
    </a>
  );
}

export default WhatsAppButton;
